import { INTRODUCTION_SECTION_ID } from 'global/constants';
import { getStudentSectionsAndSubSectionsOverview } from '../student.utils';
import type { BookmarkedSectionOverviewFragment } from '../../../shared/bookmarks/bookmark.graphql.generated';

export function getPagesToDownload(
  overviews: BookmarkedSectionOverviewFragment[],
  selectedSections: string[]
) {
  const pages: number[] = [];
  const allOverviews = getStudentSectionsAndSubSectionsOverview(overviews);
  const hasIntro = allOverviews.some(s => s.id === INTRODUCTION_SECTION_ID);

  allOverviews.forEach((s, i) => {
    if (selectedSections.length === 0 || selectedSections.includes(s.id)) {
      // the intro slide is only returned if it is bookmarked
      // so the index needs to be adjusted to get the right
      // pages
      const idx = hasIntro ? i + 1 : i + 2;
      pages.push(idx);
    }
  });
  return pages;
}
